/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {wrappedGetMonetaTransfer} from '../api'

export const useMutationWrappedGetMonetaTransfer = createReactQueryMutationHook('wrappedGetMonetaTransfer', wrappedGetMonetaTransfer)
